/** Phone storage options for sell-form picker — ordered largest to smallest (scroll from top). */
export const STORAGE_OPTIONS = [
  '2TB',
  '1TB',
  '512GB',
  '256GB',
  '128GB',
  '64GB',
  '32GB',
  '24GB',
  '18GB',
  '16GB',
  '12GB',
  '8GB',
  '6GB',
  '4GB',
  '3GB',
  '2GB',
  '1GB',
] as const

export type StorageOption = (typeof STORAGE_OPTIONS)[number]
